<script>

    import { filter } from './filter.js';
    import { formatDate } from './helpers.js';
    import Links from './Links.svelte';

    export let event = [];

    let show = true;
    function checkFilter(){
        return $filter.includes( event.location.city );
    }
    $: show = checkFilter( $filter );

</script>

{#if show}
    <li>

        <div class="grid title text-l">
            <div class="date">
                {formatDate(event.date)}
            </div>
            <div class="city">
                <h2>{event.location.city}</h2>
            </div>
            <div class="venue">{event.venue}</div>
        </div>

        <Links links={event.links} />

    </li>
{/if}

<style>

    li {
        padding: 1rem 0;
    }
    li :global( + li ){
        border-top: 1px solid currentColor;
    }
    .grid {
        display: grid;
        gap: 0 2rem;
        grid-template-columns: 2fr 3fr 3fr;
    }
    @media (max-width: 700px){
        .grid {
            grid-template-columns: 1fr 2fr;
        }
        .date {
            grid-row-end: span 2;
        }
        .city,
        .venue {
            grid-row-end: span 1;
        }
    }

</style>